<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="clearfix row breadcrumb-margin-lg">
        <div class="col-md-6 col-sm-12 mt-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item"><a href="#">Category</a></li>
              <li class="breadcrumb-item active" aria-current="page">Add Category</li>
            </ol>
          </nav>
        </div>
        <div class="text-right col-md-6 col-sm-12">
          <!-- <router-link
            :to="'/admin/category'"
            class="btn btn-outline-danger"
            title="Go to Category"><i class="mr-2 fa fa-arrow-circle-left"></i>Back</router-link> -->
          <router-link
            :to="'/admin/category/category_filter' + $route.params.id"
            class="btn btn-outline-danger"
            ><i class="mr-2 fa fa-arrow-circle-left"></i>Back</router-link
          >
        </div>

        <!-- this.$router.push({ name: "CategoryFilter", params: { id: id } }); -->
      </div>
    </div>

    <div class="clearfix row">
      <div class="mx-auto col-md-8">
        <div class="card">
          <div class="card-header bg-primary custom-title theme-backcolor">
            <h6 class="text-white fs">Add New Category</h6>
          </div>
          <v-app class="fixVapp">
            <div class="body">
              <form>
                <!-- <div class="form-group">
                   <v-autocomplete
                    attach
                    v-model="selected"
                    label="Select Domain"
                    :items="domains"
                    item-text="domain_title"
                    item-value="domain_id"
                    outlined
                    dense
                    :error-messages="errors.domain_id"
                  ></v-autocomplete>
                </div> -->
                <div class="d-flex mt-n2">
                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Category Title</label>
                      <v-text-field
                        label=""
                        v-model="category_title"
                        class="mt-n8"
                        type="text"
                        outlined
                        dense
                        :error-messages="errors.category_title"
                      />
                    </div>
                  </v-col>
                  <!-- <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Category Icon</label>
                      <v-text-field
                        label=""
                        class="mt-n8"
                        v-model="category_icon"
                        type="text"
                        outlined
                        dense
                      />
                    </div>
                  </v-col> -->
                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Category Description</label>
                      <v-text-field
                        type="text"
                        class="mt-n8"
                        label=""
                        v-model="category_description"
                        outlined
                        dense
                        :error-messages="errors.category_description"
                      />
                    </div>
                  </v-col>
                </div>
                <div class="d-flex mt-n8">
                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">SEO Name</label>
                      <v-text-field
                        type="text"
                        class="mt-n8"
                        label=""
                        v-model="seo_name"
                        outlined
                        dense
                        :error-messages="errors.seo_name"
                      />
                    </div>
                  </v-col>

                  <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <!-- <label for="">Global Faq</label> -->
                      <label class="text-muted">Global Faq</label>
                      <v-autocomplete
                        label=""
                        item-text="name"
                        item-value="id"
                        class="mt-n8"
                        :items="global_faq_items"
                        v-model="global_faq"
                        outlined
                        dense
                        :error-messages="errors.global_faq"
                      />
                    </div>
                  </v-col>
                </div>
                <div class="d-flex mt-n8">
                  <v-col lg="6" md="6" sm="6">
                    <label class="text-muted">Order</label>
                    <div class="form-group">
                      <v-text-field
                        label=""
                        class="mt-n8"
                        v-model="order"
                        type="number"
                        outlined
                        dense
                        :error-messages="errors.order"
                      />
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6">
                    <label class="text-muted">SAC (Optional)</label>
                    <div class="form-group">
                      <v-text-field
                        type="text"
                        label=""
                        v-model="sac"
                        class="mt-n8"
                        outlined
                        dense
                        :error-messages="errors.sac"
                      />
                    </div>
                  </v-col>
                </div>
                <!-- <div class="d-flex mt-n8"> -->

                <!-- <v-col lg="6" md="6" sm="6">
                    <div class="form-group">
                      <label class="text-muted">Image</label>
                      <v-file-input
                        :error-messages="errors.image"
                        dense
                        class="mt-n8"
                        outlined
                        v-model="imageCategory"
                        accept="image/png, image/jpeg, image/webp, image/bmp"
                        placeholder="Pick an image"
                        prepend-inner-icon="mdi-camera"
                        prepend-icon=""
                        label=""
                      ></v-file-input>
                    </div>
                  </v-col> -->
                <!-- </div> -->

                <!-- <v-radio-group v-model="category_feature" row>
                  <span>Category Featured </span>
                  <v-radio
                    label="Yes"
                    name="category_feature"
                    value="Y"
                    @change="domainFeatureChecked($event)"
                  ></v-radio>
                  <v-radio
                    label="No"
                    name="category_feature"
                    value="N"
                    @change="domainFeatureChecked($event)"
                  ></v-radio>
                </v-radio-group> -->

                <div class="col-md-12 text-center mt-n8 mb-n1">
                  <button
                    type="button"
                    class="text-white btn btn-primary theme-backcolor"
                    @click="AddCategory"
                  >
                    <i class="mr-2 fa fa-save"></i>Save
                  </button>
                </div>
              </form>
            </div>
            <v-overlay :value="isLoading">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../dataservice';
export default {
  components: {},
  data() {
    return {
      errors: '',
      domains: [],
      global_faq_items: [],
      global_faq: '',
      selected: null,
      category_title: '',
      category_icon: '',
      imageCategory: '',
      seo_name: '',
      sac: '',
      order: '',
      isLoading: false,
      category_description: '',
      category_isactive: 'Y',
      // category_feature:'Y',
    };
  },
  // created() {

  // },
  methods: {
    //  domainFeatureChecked(e) {
    //   this.category_feature = e.target.value;
    // },

    getOrder(id) {
      this.isLoading = true;
      DataService.getOrderById(id).then(response => {
        this.order = response.data.order;
        this.isLoading = false;
      });
    },
    AddCategory() {
      //  let loader = this.$loading.show({
      //           container: this.$refs.formContainer,
      //           canCancel: false,
      //           color:'#007BFF'
      //         });
      const data = new FormData();
      data.append('category_title', this.category_title);
      data.append('category_icon', this.category_icon);
      //  data.append("category_feature", this.category_feature);
      data.append('category_description', this.category_description);
      data.append('seo_name', this.seo_name);
      data.append('domain_id', this.$route.params.id);
      data.append('category_isactive', this.category_isactive);
      data.append('sac', this.sac);
      data.append('image', this.imageCategory);
      data.append('global_faq', this.global_faq);
      data.append('order', this.order);
      DataService.createCategory(data)
        .then(response => {
          this.s('Category', 'Record Added Successfully');
          this.$router.push({
            name: 'CategoryFilter',
            params: { id: this.$route.params.id },
          });
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.e("Oop's", 'Something went wrong.');
        });
    },
    getGlobalFaq() {
      DataService.globleFaqMasterGet()
        .then(response => {
          this.global_faq_items = response.data;
        })
        .catch(error => {});
    },
  },
  created() {
    this.getGlobalFaq();
    this.getOrder(this.$route.params.id);
    DataService.getAllDomain()
      .then(response => {
        this.domains = response.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },
};
</script>
<style scoped>
.fixVapp {
  height: 100px;
}

.custom-title {
  padding: 12px 20px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.fs {
  font-size: 18px !important;
  font-weight: 600 !important;
}

.custom-file-input .v-input__prepend {
  margin-top: 24px;
}
</style>
